import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import ScoreNumber from "./ScoreNumber";
import ScoreTag from "./ScoreTag";
import "./index.css";
import TranslationService from "../../services/translation/TransationService";

function RatingScoreCard({ scoreNumber, lastAutoevaluationDate }) {
  const day = lastAutoevaluationDate.getDate();
  const month = lastAutoevaluationDate.getMonth() + 1;
  const year = lastAutoevaluationDate.getFullYear();

  let monthString = `${month}`;
  if (month < 10) {
    monthString = `0${month}`;
  }
  let dayString = `${day}`;
  if (day < 10) {
    dayString = `0${day}`;
  }

  let style = {};
  if (scoreNumber === 1) {
    style = { borderBottomLeftRadius: 0 };
  }

  if (scoreNumber === 5) {
    style = { borderBottomRightRadius: 0 };
  }
  return (
    <div>
      <div className="score-card" style={style}>
        <p className="title">
          {TranslationService.get("UPDATED")}{" "}
          {`${dayString}/${monthString}/${year}`} *
        </p>
        <div className="bar"> </div>
        <Grid
          container
          className="score-numbers-container"
          justify="space-evenly"
          alignItems="center"
        >
          <Grid item>
            <ScoreNumber number={1} scoreNumber={scoreNumber} />
          </Grid>
          <Grid item>
            <ScoreNumber number={2} scoreNumber={scoreNumber} />
          </Grid>
          <Grid item>
            <ScoreNumber number={3} scoreNumber={scoreNumber} />
          </Grid>
          <Grid item>
            <ScoreNumber number={4} scoreNumber={scoreNumber} />
          </Grid>
          <Grid item>
            <ScoreNumber number={5} scoreNumber={scoreNumber} />
          </Grid>
        </Grid>
      </div>
      <ScoreTag scoreNumber={scoreNumber} />
    </div>
  );
}

RatingScoreCard.propTypes = {
  scoreNumber: PropTypes.number.isRequired,
  lastAutoevaluationDate: PropTypes.instanceOf(Date)
};

RatingScoreCard.defaultProps = {
  lastAutoevaluationDate: Date.now()
};

export default RatingScoreCard;



// WEBPACK FOOTER //
// ./src/components/RatingScoreCard/RatingScoreCard.jsx